var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg-icon-container"},[_c('span',{staticClass:"svg-icon",class:[`icon-${_vm.icon}`, _vm.experience],style:(_vm.style)})])
}
var staticRenderFns = []

export { render, staticRenderFns }